import { Type as T } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { EDisplayFormat } from '../_common/enum.js';
import { validateField } from '../index.js';

export const CreateCampaignSchema = T.Object({
  name: T.String({ minLength: 1, error: 'Nome da campanha é um campo obrigatório' }),
  displayFormat: T.Enum(EDisplayFormat, { error: 'Formato de exibição é um campo obrigatório' }),
  startDate: T.String({ error: 'Data de início é um campo obrigatório' }),
  endDate: T.Optional(T.String()),
  description: T.Optional(T.String()),
  medias: T.Array(T.String({ format: 'uuid', error: 'Medias deve ser um array de uuid' })),
  segmentation: T.Array(
    T.Object({
      uuid: T.String({ format: 'uuid', error: 'UUID é um campo obrigatório do tipo uuid' }),
      name: T.String({ error: 'Nome é um campo obrigatório' }),
      isState: T.Boolean({ error: 'isState é um campo obrigatório' }),
    })
  ),
  brand: T.String({ format: 'uuid', error: 'A marca é um campo obrigatório do tipo uuid' }),
  thumbnailFileType: T.Optional(T.String({ error: 'Thumbnail é obrigatória' })),
  /** Pre-uploaded thumbnail key from image.uploadCompressed endpoint */
  thumbnailKey: T.String({ error: 'Thumbnail é obrigatória' }),
});

export type CreateCampaignInputType = typeof CreateCampaignSchema.static;

export async function ValidateCreateCampaignInput(value: unknown): Promise<CreateCampaignInputType> {
  return Value.Parse(CreateCampaignSchema, value);
}

export function checkCampaignCreateInput(field: string, value: unknown): string | boolean {
  return validateField(CreateCampaignSchema, field, value);
}
